module.exports = __webpack_public_path__ + "img/ArsredovisningOnline-logo.e082b02e.png";